import * as Sentry from '@sentry/react';
export const createInitSentry = ({ appName, dsn, environment, version, tracesSampleRate, }) => {
    const isSentryEnabled = !!dsn;
    const initSentry = () => {
        if (!isSentryEnabled)
            return;
        Sentry.init({
            dsn,
            release: `${appName}@${version}`,
            tracesSampleRate,
            integrations: [Sentry.browserTracingIntegration()],
            environment,
        });
    };
    return { isSentryEnabled, initSentry };
};
